import { Moon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { SleepStepContainer } from "../SleepStepContainer"
import { useSleepForm } from "../SleepFormContext"

interface OnsetStepProps {
  onsetMethods: { id: string; description: string }[]
  childName?: string
  onNext: () => void
}

export function OnsetStep({ onsetMethods, childName, onNext }: OnsetStepProps) {
  const form = useSleepForm()

  return (
    <SleepStepContainer>
      <div className="space-y-2">
        <h3 className="text-lg font-medium text-center mb-4">
          How did {childName || 'your baby'} fall asleep?
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto">
          {onsetMethods.map((method) => (
            <Button
              key={method.id}
              type="button"
              variant={form.watch("onset_method_id") === method.id ? "default" : "outline"}
              className="w-full py-3 px-4 h-auto text-left justify-start hover:bg-accent/50 whitespace-normal"
              onClick={() => {
                form.setValue("onset_method_id", method.id)
                form.clearErrors("onset_method_id")
                onNext()
              }}
            >
              <Moon className="mr-2 h-4 w-4 shrink-0" />
              <span className="text-sm line-clamp-2">{method.description}</span>
            </Button>
          ))}
        </div>
        {form.formState.errors.onset_method_id && (
          <p className="text-sm text-destructive">
            {form.formState.errors.onset_method_id.message}
          </p>
        )}
      </div>
    </SleepStepContainer>
  )
}